<template>
  <v-card
    class="d-block handle column-handle"
    style="
      background-color: #fff;
      position: absolute;
      margin: auto;
      top: -30px;
      font-size: 10px;
    "
    @click.prevent="$emit('click')"
    @click.stop="$emit('click')"
    @dblclick.prevent="$emit('click')"
    @dblclick.stop="$emit('click')"
  >
    <v-icon>mdi-drag-horizontal</v-icon>
  </v-card>
</template>

<script>
export default {
  name: 'ColumnBulkSelectButton'
}
</script>

<style scoped>
.handle {
  cursor: grab  !important;
}
</style>
